import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ImageFetch from "./ImageFetch";
import { useEffect, useState } from "react";

const avatarSettings = {
    center: false,
    items: 1,
    loop: false,
    margin: 15,
    nav: true,
    autoplay: false,
    autoWidth: true,
    dots: false,
    responsive: {
      1200: {
      },
    },
  };
const BASE_URL = "https://hh-devserver-bucket.s3.us-east-2.amazonaws.com/Assets/Images/Meme-Generator-Assets/Avatars/"
export default ({bannerAvatars,addAssets,avatarChecks,selectedAvatarCategory,setSelectedAvatarCategory})=>{
  const [loader,setLoader] = useState(true)
    const [reRender,setRerender] = useState(false)

    useEffect(()=>{
        setLoader(true)
        setRerender(!reRender)
    },[selectedAvatarCategory])  
  return (
        <div id="slider-block">
          
              <div style = {{overflowX:"hidden"}} className="slider-title">
                <h3>Select Avatars:</h3>
                <form style = {{overflowX:"hidden"}} className="tags">
                  {avatarChecks.map((option, index) => (
                      <label key={index} style={selectedAvatarCategory==option?{backgroundColor:"#00a5a6"}:{backgroundColor:"rgb(2 36 36 / var(--tw-bg-opacity))"}} className="tag">
                      <input
                        type="checkbox"
                        checked={selectedAvatarCategory==option}
                        onChange={() => setSelectedAvatarCategory(option)}
                      />
                      {option}
                    </label>
                  ))}
                </form>
              </div>
              {loader ? <div className="loader"></div> :<></>}
              <OwlCarousel
                className="artis-slider  owl-theme"
                {...avatarSettings}
              >
                {bannerAvatars[selectedAvatarCategory].map((avatar,index) => {
                  return (
                    <ImageFetch 
                  addAssets={addAssets} 
                  link={BASE_URL+`${selectedAvatarCategory}/`+avatar} 
                  incrementLoader = {()=>{setLoader(false)}} 
                  imagesLoaded={true} 
                  reRender={reRender} 
                  selectedCategory={selectedAvatarCategory}
                  key={index}
                  />
                  );
                })}
              </OwlCarousel>
            </div>
    )
}